import React from "react"

function Feature2(props) {
  return (

    <div class="d-flex">
      <div className="icon text-primary">
        <img width="48" height="48" src={props.iconpath} alt=""/>
      </div>
      
      <div class="ml-5">
        <h4 class="mb-1">{props.title}</h4>
        <p class="text-muted mb-6">{props.description}</p>

      </div>

    </div>
  )
}

export default Feature2